var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutomatedCampaignsDarkblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3214 6.75L11.0357 11.0357L6.75 6.75M11.0357 11.0357V0.75M19.6071 7.60714C20.0618 7.60714 20.4979 7.78776 20.8193 8.10924C21.1407 8.43074 21.3214 8.86677 21.3214 9.32143V21.3214C21.3214 21.7761 21.1407 22.2122 20.8193 22.5336C20.4979 22.855 20.0618 23.0357 19.6071 23.0357H2.46429C2.00962 23.0357 1.57359 22.855 1.2521 22.5336C0.930617 22.2122 0.75 21.7761 0.75 21.3214V9.32143C0.75 8.86677 0.930617 8.43074 1.2521 8.10924C1.57359 7.78776 2.00962 7.60714 2.46429 7.60714M0.75 9.76716L11.0357 17.0357L21.3214 9.76716",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedCampaignsDarkblue);
export default __webpack_public_path__ + "static/media/automated-campaigns-darkblue.646c2ec6.svg";
export { ForwardRef as ReactComponent };